import "./label.scss";
import { useTheme } from "@mui/material/styles";
const Label = () => {
  const theme = useTheme();
  return (
    <div className="label">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="30pt"
        height="50pt"
        // viewBox="0 0 214.000000 388.000000"
        viewBox="0 10 214.000000 388.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <metadata></metadata>
        <g
          transform="translate(0.000000,388.000000) scale(0.100000,-0.100000)"
          fill={theme.color.secondary}
          stroke="none"
        >
          <path
            d="M1827 3701 c-5 -105 -12 -149 -22 -161 -8 -9 -15 -35 -15 -58 0 -22
-5 -44 -11 -47 -6 -4 -9 -21 -8 -39 4 -66 -1 -96 -16 -96 -12 0 -15 -15 -15
-75 0 -63 -3 -76 -19 -85 -13 -7 -17 -16 -14 -31 6 -21 5 -21 -20 -4 -14 9
-31 14 -37 10 -6 -4 -18 -1 -27 6 -12 11 -17 11 -27 -2 -11 -16 -55 -28 -128
-35 -35 -3 -38 -1 -38 21 0 14 -4 26 -10 26 -16 2 -23 4 -62 18 -34 11 -38 16
-38 46 0 25 -6 38 -21 46 -19 9 -21 17 -15 55 3 26 2 44 -4 44 -6 0 -11 12
-11 28 -1 20 -2 22 -6 7 -3 -11 -9 -24 -13 -30 -4 -5 -8 -29 -8 -53 -1 -24 -7
-49 -16 -57 -8 -9 -13 -22 -10 -29 6 -16 -21 -46 -42 -46 -10 0 -14 -14 -14
-54 0 -59 -1 -60 -42 -70 l-28 -6 0 100 0 100 -40 0 -40 0 0 68 0 68 -66 24
-66 23 5 53 c5 44 2 55 -15 71 -11 10 -24 27 -29 38 -7 19 -8 19 -8 -2 -1 -12
-6 -25 -13 -29 -15 -10 -68 50 -69 79 -1 20 -2 20 -13 -5 -13 -31 -50 -68 -66
-68 -6 0 -15 12 -21 28 -10 25 -12 26 -19 7 -4 -11 -17 -28 -28 -39 -19 -16
-20 -26 -15 -82 6 -61 5 -64 -19 -73 -21 -8 -24 -14 -20 -40 5 -36 -5 -39 -41
-11 -27 22 -42 94 -24 118 7 8 5 18 -7 30 -9 10 -16 29 -17 43 l-1 24 -11 -26
c-7 -14 -18 -33 -26 -43 -10 -12 -11 -19 -2 -30 8 -10 9 -16 1 -21 -5 -3 -10
-18 -10 -33 0 -40 -8 -46 -97 -77 -105 -36 -105 -36 -105 -79 0 -23 -5 -40
-14 -43 -11 -4 -14 -28 -14 -104 l0 -99 -35 0 -35 0 0 -202 0 -202 30 29 c16
16 33 26 36 22 18 -17 15 -104 -4 -154 -11 -29 -19 -53 -18 -53 1 0 19 9 41
20 48 24 76 25 121 4 42 -20 35 -33 -40 -72 -38 -19 -66 -26 -109 -26 l-57 1
0 -39 c0 -36 2 -38 25 -32 14 3 41 3 60 0 31 -6 34 -9 25 -26 -6 -11 -33 -42
-60 -69 -58 -58 -68 -101 -24 -101 23 0 25 -3 19 -27 -3 -16 -15 -46 -26 -69
-10 -22 -19 -55 -19 -72 0 -30 2 -32 26 -26 l27 7 -5 -69 c-3 -39 -14 -91 -26
-118 -17 -37 -22 -68 -22 -130 1 -74 3 -82 25 -99 28 -20 31 -16 13 16 -21 39
-28 91 -17 131 10 37 57 96 77 96 14 0 44 -116 44 -174 0 -70 -18 -132 -45
-151 -12 -8 -39 -18 -59 -22 -38 -6 -38 -6 -38 -53 l0 -47 63 0 c89 1 122 -19
137 -82 14 -60 8 -97 -31 -174 l-29 -59 67 -86 c270 -347 662 -626 1069 -760
201 -67 452 -112 619 -112 l85 0 0 925 0 925 -410 0 -410 0 0 -264 c0 -214 -3
-266 -14 -275 -9 -8 -46 -11 -103 -9 l-88 3 -3 614 c-2 485 0 616 10 623 7 4
49 8 92 8 63 0 81 -3 92 -17 10 -14 13 -77 14 -275 l0 -258 410 0 410 0 0 490
0 490 -30 0 c-20 0 -30 5 -30 15 0 8 -9 15 -20 15 -17 0 -20 7 -20 41 0 26 -7
50 -20 66 -16 20 -20 41 -20 94 0 62 -2 69 -20 69 -18 0 -20 7 -20 65 0 37 -4
65 -10 65 -5 0 -10 22 -10 49 0 37 -5 52 -20 62 -18 12 -21 30 -28 159 l-7
145 -8 -144z m-1157 -857 c0 -28 -34 -75 -70 -97 l-35 -22 42 -3 c30 -2 51
-12 73 -32 16 -15 30 -32 30 -38 0 -29 -124 -18 -169 16 -22 16 -26 27 -25 65
0 52 18 78 74 108 44 23 80 24 80 3z m209 -63 c51 -23 48 -36 -10 -49 -80 -19
-224 -11 -224 13 0 13 60 46 98 55 41 9 93 2 136 -19z m-471 -41 c-4 -36 -14
-61 -35 -88 l-30 -37 63 0 c52 0 67 -4 85 -21 29 -29 19 -40 -45 -55 -137 -30
-214 46 -154 153 21 37 90 98 111 98 5 0 7 -22 5 -50z m610 -792 c2 -488 1
-508 -17 -517 -21 -12 -159 -10 -178 2 -10 6 -13 118 -13 502 0 271 3 501 6
510 5 13 22 15 103 13 l96 -3 3 -507z m-250 -1 l2 -387 -27 -11 c-29 -11 -158
-7 -171 6 -4 3 -8 175 -10 382 -2 278 0 379 9 389 9 11 34 14 103 12 l91 -3 3
-388z m987 -163 c9 -19 19 -50 22 -69 6 -40 -22 -137 -47 -160 -17 -15 -19
-13 -29 35 -13 62 -14 101 0 160 18 84 27 90 54 34z m-91 -205 c19 -22 26 -42
26 -72 l0 -41 37 44 c34 40 98 78 111 66 9 -10 -30 -98 -57 -128 -37 -41 -99
-49 -131 -17 -31 33 -40 62 -40 125 0 64 15 70 54 23z m-86 -209 c22 -43 22
-57 5 -114 -4 -15 4 -12 35 13 40 33 102 54 128 44 20 -7 18 -15 -16 -61 -40
-55 -99 -86 -150 -77 -33 6 -42 13 -59 49 -12 23 -21 53 -21 66 0 37 33 131
44 127 6 -2 21 -23 34 -47z m-143 -150 c20 -39 19 -83 -5 -129 l-19 -39 49 19
c55 21 126 25 150 9 12 -9 8 -17 -25 -47 -49 -43 -92 -63 -140 -63 -42 0 -90
22 -99 45 -12 31 -6 116 10 148 19 36 53 87 59 87 3 0 11 -13 20 -30z m-817
-75 c88 -20 97 -26 82 -54 -31 -59 -139 -80 -213 -42 l-38 19 37 -51 c55 -76
84 -145 84 -200 l0 -48 -32 17 c-91 46 -161 131 -174 210 -9 61 23 128 67 142
81 25 102 26 187 7z m652 -71 c0 -52 -19 -94 -56 -123 l-27 -21 69 0 c71 0
154 -27 154 -50 0 -14 -72 -46 -122 -55 -56 -10 -104 2 -143 37 -38 32 -43 56
-25 118 15 50 119 158 141 145 5 -4 9 -26 9 -51z m-380 -20 c0 -17 -44 -81
-67 -98 -16 -12 -51 -22 -87 -25 l-61 -6 46 -27 c76 -45 149 -138 135 -174 -6
-15 -66 -3 -138 28 -82 35 -135 118 -121 189 7 36 68 86 126 105 43 13 167 19
167 8z m185 -31 c-12 -66 -46 -102 -121 -128 l-36 -12 59 -12 c90 -17 198 -99
162 -122 -26 -16 -142 -10 -187 11 -51 23 -64 35 -86 79 -23 43 -14 80 32 131
39 43 121 89 161 89 22 1 23 -2 16 -36z"
          />
        </g>
      </svg>
    </div>
  );
};

export default Label;
